import {DesignerVersion} from '@mintdata-wsp/common/state/ui/visualDesigner/DesignState';
import {BoxTypes} from '@mintdata-wsp/common/state/ui/visualDesigner/surface/component/Box';
import {IMigration} from '@mintdata-wsp/wsp/controllers/visualDesigner/designState/DesignMigrationController';
import {Assert} from '@mintdata/mint-kit/impl/util/Assert';
import {IdUtil} from '@mintdata/mint-kit/impl/util/IDUtil';

const MIGRATED_VERSION:DesignerVersion = 30;

export const migration_29_30:IMigration = {
    from: MIGRATED_VERSION - 1,
    to: MIGRATED_VERSION,
    migrate: (designState:any) =>
    {
        Assert.yes(designState.designerVersion === MIGRATED_VERSION - 1);

        console.log(`migration ${MIGRATED_VERSION - 1}->${MIGRATED_VERSION} designState`, designState);

        if( designState.surface && designState.surface.pages )
        {
            designState.surface.onViewportResizeProp = {
                id: IdUtil.newGUID(),
                name: 'onViewportResize',
                boxId: null,
                bindingId: null,
                isEnabled: false
            };
        }

        designState.designerVersion = MIGRATED_VERSION;

        return designState;
    }
};
